import React, { useState, useEffect } from 'react';
import { DefaultTheme, ThemeProvider } from 'styled-components';
import { theme } from './theme';
import { theme as themeEnogen } from './themeEnogen';
import { Routing } from './pages/Routing/Routing';
import { GlobalStyle } from './styles';
import { ThemeName } from './logic/store/UI/UISlice';
import * as queryString from 'query-string';
import { setMasquerade } from './logic/Api/Api';
import { useAppDispatch } from './logic/store/Store';
import { clearLoadingState } from './logic/store/User/UserInfoSlice';

const App = () =>
{
	const [currentThemeFile, setCurrentThemeFile] = useState<DefaultTheme>();
	const dispatch = useAppDispatch();

	// Handle bfcache restoration - reset loading states when page is restored from cache
	useEffect(() =>
	{
		const handlePageShow = (event: PageTransitionEvent) =>
		{
			// event.persisted is true when page is restored from bfcache
			if (event.persisted)
			{
				dispatch(clearLoadingState());
			}
		};

		window.addEventListener('pageshow', handlePageShow);
		
		return () =>
		{
			window.removeEventListener('pageshow', handlePageShow);
		};
	}, [dispatch]);

	// Get any relevant parameters from the url
	const parsed = queryString.parse(location.search);
	if(parsed.masquerade)
	{
		setMasquerade(String(parsed.masquerade));
	}
	
	const changeTheme = (name: ThemeName) =>
	{
		switch (name) 
		{
			case ThemeName.Enogen:
			{
				setCurrentThemeFile(themeEnogen);

				// Change the favicon
				const favicon = document.getElementById('favicon');
				favicon.setAttribute('href', '/enogen_favicon.ico');

				// Change the site title
				document.title = 'E-Luminate';

				break;
			}
			default:
			{
				setCurrentThemeFile(theme);

				// Change the favicon
				const favicon = document.getElementById('favicon');
				favicon.setAttribute('href', '/favicon.ico');

				// Change the site title
				document.title = 'GHX Fields';
				
				break;
			}
		}
	};

	return (
		<ThemeProvider theme={currentThemeFile ?? theme}>
			<GlobalStyle />
			<Routing changeTheme={changeTheme} />
		</ThemeProvider>
	);
};

export default App;
